import React from "react";
import "../../stylesheets/_home.scss";
import "../../stylesheets/screen.css.scss";
import CrmImg from "../../Assets/images/CRM.svg";

import PropTypes from "prop-types";

const Card = (props) => {
  const handleMouseOut = (event) => {
    const card = event.currentTarget;
    if (card) {
      card.scrollTop = 0;
    } // Scrolls the current card element to the top
  };
  return (
    <div className="card">
      <div className="card-body" data-testid={"card-body"} onMouseLeave={handleMouseOut}>
        <div className="card-logo">
          <img
            src={CrmImg}
            alt="icon"
          ></img>
        </div>
        <h1 className="card-heading">{props["name"]}</h1>{" "}
        <p className="card-description"> {props["desc"]} </p>
        <p> </p>
      </div>
    </div>
  );
};
Card.propTypes = {
  name: PropTypes.string,
  desc: PropTypes.string,
};
export default Card;
